/**
 * ProjectPage — back-compat redirect from /project/:id to v2's own
 * /project/:id/workspace. The workspace is now v2-native (chat panel +
 * production board visualization), no more redirect to v1.
 *
 * Existing deep-links to /project/:id (composer success in earlier
 * builds, dashboard tiles before the rewire) still resolve here.
 */
import { Navigate, useParams } from 'react-router-dom'

export function ProjectPage() {
  const { id } = useParams<{ id: string }>()
  if (!id) return <Navigate to="/dashboard" replace />
  return <Navigate to={`/project/${id}/workspace`} replace />
}
